module.exports = __webpack_public_path__ + "static/media/ClickHere_Button@3x.0d8fbd23.png";